<div class="close-wrapper">
  <button type="button" class="close" aria-label="Close" (keydown.enter)="$event.preventDefault()" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

@if (youtubeUrl) {
  <iframe
    width="500"
    height="315"
    src=""
    title="YouTube video player"
    [src]="youtubeUrl | trustHtml: 'resourceUrl'"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
}
